import { Button, Skeleton } from '@teach/ui'
import { useGetCreditPackagesQuery } from '@/features/ai/creditsApi'
import { fittingPackageId, sortPackages, type Deficit } from './lib/packageFit'
import { PackageCard } from './PackageCard'
import type { CreditPackage } from './lib/paymentMethods'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  deficit: Deficit | null
  /** Есть ли почта в профиле: без неё рублёвого способа не существует. */
  canPayByCard: boolean
  /** Страна профиля: от неё зависят способы и валюта (PRD #71, п.28). */
  country: string | null
  onSelect: (pkg: CreditPackage) => void
}

export const PackagesGrid = ({ deficit, canPayByCard, country, onSelect }: Props) => {
  const { data, isLoading, isError, refetch } = useGetCreditPackagesQuery()
  const m = useMessages(messages)

  if (isLoading)
    return (
      <div className="grid gap-4 sm:grid-cols-2">
        <Skeleton className="h-56" />
        <Skeleton className="h-56" />
      </div>
    )

  // Недоехавшая витрина объясняется текстом с повтором, а не пустым диалогом —
  // тот же приём, что у недоехавшей сметы в `DrawImagesBody`.
  if (isError || !data)
    return (
      <div className="space-y-2 text-center">
        <p className="text-sm text-muted-foreground">{m.packagesFailed}</p>
        <Button variant="outline" size="sm" onClick={() => void refetch()}>
          {m.retry}
        </Button>
      </div>
    )

  if (data.length === 0)
    return <p className="text-center text-sm text-muted-foreground">{m.packagesUnavailable}</p>

  const fitId = fittingPackageId(data, deficit, canPayByCard, country)
  return (
    <div className="grid gap-3 sm:grid-cols-2 sm:gap-4">
      {sortPackages(data).map((pkg) => (
        <PackageCard
          key={pkg.id}
          pkg={pkg}
          fits={pkg.id === fitId}
          canPayByCard={canPayByCard}
          country={country}
          onSelect={() => onSelect(pkg)}
        />
      ))}
    </div>
  )
}
